import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'

// create an axios instance
const service = axios.create({
    baseURL: process.env.VUE_APP_API_ENDPOINT + '/api',

    timeout: 60000, // request timeout
    headers: {
        common: { // can be common or any other method
            'Access-Control-Allow-Origin': '*'
        }
    }
})

// request interceptor
service.interceptors.request.use(
    config => {
        // Do something before request is sent
        if (store.getters.token != "" && getToken()) {
            config.headers.Authorization = 'Bearer ' + getToken()
        }
        return config
    },
    error => {
        // Do something with request error
        console.log(error) // for debug
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => response,
    error => {
        console.log(error)
        if (error.response === undefined) {
            var msg = 'ارتباط شما با سرور برقرار نیست. لطفا از اتصال خود به اینترنت مطمئن شوید.'
            var er = { response: { data: { Message: msg } } }
            return Promise.reject(er)
        }
        return Promise.reject(error)
    }
)

export default service